import { darkTheme, lightTheme } from 'core/styles/theme.styled';
import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { DefaultTheme } from 'styled-components';
import { AuthContext } from '../auth/auth';
import { getUserThemePreference, updateUserThemePreference } from 'core/services/theme/theme';

// Define type for theme
type Theme = 'lightTheme' | 'darkTheme';

// Define context value type
export interface ThemeContextType {
    apptheme: DefaultTheme; 
    toggleTheme: () => void;
  }

// Create the context
export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);


// Provider component
export const AppThemeProvider = ({ children }: { children: ReactNode }) => {
  const [apptheme, setAppTheme] = useState<DefaultTheme>(darkTheme);
  const { checkAuthToken } = useContext(AuthContext)

  useEffect(() => {
    const fetchTheme = async () => {
      const token = await checkAuthToken();
      const themePreference = await getUserThemePreference(token);
      console.log(themePreference);
      setAppTheme(themePreference === "darkTheme" ? darkTheme : lightTheme);
    };
 
    fetchTheme();
  }, []);

  const toggleTheme = () => {
    const newTheme = apptheme.name === "light-theme" ? darkTheme : lightTheme;
    setAppTheme(newTheme);
    console.log("Themecolor",apptheme);
    (async () => {
        const token = await checkAuthToken();
        await updateUserThemePreference(token, newTheme.name === "dark-theme" ? "darkTheme" : "lightTheme");
    })();
  };

  return (
    <ThemeContext.Provider value={{ apptheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook for easier access
export const useAppTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
